import Loadable from 'react-loadable';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

const createLoadingComponent = () => {
	return UFOLoadHold({
		name: 'LoadingConversationAssistantBundle',
	});
};

export default Loadable({
	loader: () =>
		import(/* webpackChunkName: "@atlaskit-internal_conversation-assistant" */ './main').then(
			(m) => m.default || m,
		),
	loading: createLoadingComponent,
});
